module.exports = __webpack_public_path__ + "static/media/welcome.292d3456.png";